import { render } from "./changeSubsfee.vue?vue&type=template&id=28a79f6b"
import script from "./changeSubsfee.vue?vue&type=script&lang=js"
export * from "./changeSubsfee.vue?vue&type=script&lang=js"

import "./changeSubsfee.vue?vue&type=style&index=0&id=28a79f6b&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__